import React from "react";
import { companyInfo } from "../../data/siteData";

const quoteChecklist = [
  "Your project type or the metalwork you need",
  "Location of the site",
  "Rough dimensions or drawings if available",
  "Preferred finish, style or reference photos",
  "Your target timeline",
];

function Contact() {
  return (
    <div className="page">
      <section className="page-hero">
        <p className="section-eyebrow">Contact</p>
        <h1>Start the conversation with the details you already have.</h1>
        <p>
          If you have dimensions, sketches, pictures or just an idea of the finish
          you want, Touchmark can help you shape the scope and next step.
        </p>
      </section>

      <section className="section contact-layout">
        <article className="info-card contact-card">
          <p className="card-kicker">Direct contact</p>
          <h2>Reach the team quickly</h2>
          <div className="contact-links">
            <a href={`tel:${companyInfo.phonePrimary}`}>{companyInfo.phonePrimaryIntl}</a>
            <a href={`tel:${companyInfo.phoneSecondary}`}>{companyInfo.phoneSecondaryIntl}</a>
            <a href={`mailto:${companyInfo.email}`}>{companyInfo.email}</a>
            <a href={companyInfo.whatsappLink} target="_blank" rel="noreferrer">
              WhatsApp chat
            </a>
          </div>
        </article>

        <article className="info-card contact-card">
          <p className="card-kicker">What to send</p>
          <h2>Make the quote process faster</h2>
          <ul className="bullet-list">
            {quoteChecklist.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </article>
      </section>

      <section className="section section--contrast">
        <div className="section-heading">
          <p className="section-eyebrow">Locations</p>
          <h2>Office and workshop base</h2>
        </div>
        <div className="card-grid card-grid--locations">
          {companyInfo.officeAddresses.map((address) => (
            <article key={address} className="info-card info-card--compact">
              <p>{address}</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Contact;
